import { Anchor, Box, Group, Text } from '@mantine/core';
import { useConsentIfAvailable } from '../lib/consent/ConsentProvider';
import { CONTACT_URL, PRIVACY_POLICY_URL } from '../lib/externalLinks';

// The withdraw path for analytics consent: a plain footer link that reopens the banner, rather
// than a toggle that advertises itself. Renders nothing outside a ConsentProvider.
export function CookiePreferencesButton({ color = 'var(--text-muted)' }: Readonly<{ color?: string }>) {
  const consent = useConsentIfAvailable();
  if (!consent) return null;
  return (
    <Anchor component="button" type="button" size="xs" c={color} onClick={consent.reopen}>
      Cookie preferences
    </Anchor>
  );
}

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      style={{
        borderTop: '1px solid var(--border-default)',
        background: 'var(--bg-surface)',
      }}
    >
      <Group
        justify="space-between"
        align="center"
        wrap="wrap"
        gap="md"
        px="lg"
        py="sm"
        style={{ maxWidth: 1280, margin: '0 auto' }}
      >
        <Text size="xs" c="var(--text-muted)">© {year} Cloudhouse</Text>
        <Group gap={20}>
          <Anchor href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer" size="xs" c="var(--text-muted)">
            Privacy
          </Anchor>
          <CookiePreferencesButton />
          <Anchor href={CONTACT_URL} target="_blank" rel="noreferrer" size="xs" c="var(--text-muted)">
            Support
          </Anchor>
        </Group>
      </Group>
    </Box>
  );
}
